<template>
	<div>
		<vx-card title="Informatie" class="text-md" noShadow cardBorder>

			<img v-if="order.order.type === 1" src="@/assets/images/orders/types/bol.png" alt="content-img"
				 style="max-height: 60px; position: absolute; top: -40px; right: 20px;">
			<img v-if="order.order.type === 2" src="@/assets/images/orders/types/lightspeed.png" alt="content-img"
				 style="max-height: 60px; position: absolute; top: -40px; right: 20px;">

			<div class="vx-row">
				<div class="vx-col w-1/2">
					<div>
						<h6>Bestelnummer:</h6>
						<p>
							{{ order.order.type_id_visible }}
							<font-awesome-icon class="fa-icon cursor-pointer ml-2"
											   :icon="['far', 'copy']"
											   style="font-size: 1.0rem"
											   @click="copyBolOrderId" />
						</p>
					</div>
				</div>
				<div class="vx-col w-1/2">
					<div>
						<h6>Totale waarde bestelling:</h6>
						<p>€{{ order.order.order_price }}</p>
					</div>
				</div>

			</div>
			<div class="vx-row">
				<div class="vx-col w-full mt-5">
					<h6>Besteldatum:</h6>
					<p>{{ order.order.order_placed_date_time }}</p>
				</div>
			</div>
			<div class="vx-row" v-if="order.order.dropship">
				<div class="vx-col w-full mt-5" v-if="order.order.dropship_reference !== null">
					<h6>Dropshipper referentie:</h6>
					<p>{{ order.order.dropship_reference }}</p>
				</div>
				<div class="vx-col w-full mt-5" v-else>
					<h6>Dropshipper referentie:</h6>
					<p>-</p>
				</div>
			</div>
		</vx-card>
	</div>
</template>

<script>
export default {
	props: {
		order: Object,
	},
	methods: {
		copyBolOrderId() {
			this.$copyText(this.order.order.type_id_visible).then(result => {
				this.$vs.notify({
					title: 'Yes!',
					text: 'Dit bestelnummer is succesvol naar je klembord gekopieerd!',
					color: 'success',
				});
			}).catch(error => {
				this.$vs.notify({
					title: 'Oops!',
					text: 'Het kopiëren is mislukt!',
					color: 'danger',
				});
			});
		},
	}
}
</script>
